(function () {
  if (window.__hmChk) return;
  window.__hmChk = true;

  var busy = null;
  var again = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function readMap() {
    var nodes = document.querySelectorAll('script[data-hm-chk-map]');
    if (!nodes.length) return null;
    var m = {};
    nodes.forEach(function (n) {
      try { Object.assign(m, JSON.parse(n.textContent)); } catch (e) {}
    });
    return m;
  }

  function sorted(o) {
    var out = {};
    Object.keys(o).sort().forEach(function (k) { out[k] = o[k]; });
    return JSON.stringify(out);
  }

  function desired(item, map) {
    var pid = String(item.product_id);
    if (pid === '__keys' || !(pid in map)) return null;
    if (item.final_line_price === 0) return null;
    var want = map[pid];
    var keys = (Array.isArray(map.__keys) ? map.__keys : []).filter(Boolean);
    var props = Object.assign({}, item.properties || {});
    var next = Object.assign({}, props);
    if (props._hm_chk) {
      if (keys.indexOf(props._hm_chk) === -1) delete next[props._hm_chk];
      delete next._hm_chk;
    }
    keys.forEach(function (k) {
      if (!want || k !== want.k) delete next[k];
    });
    if (want && want.k && want.v) next[want.k] = want.v;
    if (sorted(next) === sorted(props)) return null;
    return next;
  }

  function getCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function change(line, qty, props) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, properties: props })
    }).then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    var dst = document.getElementById('CartDrawer');
    if (!dst) return Promise.resolve();
    return fetch(root() + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.getElementById('CartDrawer');
        if (src) dst.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function swapKeys(keys) {
    var olds = Object.keys(keys);
    if (!olds.length) return;
    document.querySelectorAll('main *').forEach(function (el) {
      for (var a = 0; a < el.attributes.length; a++) {
        var at = el.attributes[a];
        var v = at.value;
        if (!v || v.indexOf(':') === -1) continue;
        var nv = v;
        for (var k = 0; k < olds.length; k++) {
          if (nv.indexOf(olds[k]) !== -1) nv = nv.split(olds[k]).join(keys[olds[k]]);
        }
        if (nv !== v) el.setAttribute(at.name, nv);
      }
    });
  }

  function run(noRefresh) {
    var map = readMap();
    if (!map) return Promise.resolve(false);
    var changed = false;
    var guard = 0;
    var keys = {};
    function step() {
      if (guard++ > 20) return Promise.resolve();
      return getCart().then(function (cart) {
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          var next = desired(items[i], map);
          if (next) {
            changed = true;
            var oldKey = items[i].key;
            var idx = i;
            return change(i + 1, items[i].quantity, next).then(function (res) {
              var nk = res && res.items && res.items[idx] && res.items[idx].key;
              if (oldKey && nk && nk !== oldKey) keys[oldKey] = nk;
            }).then(step);
          }
        }
      });
    }
    return step().then(function () {
      if (!changed || noRefresh) return changed;
      if (document.querySelector('[data-hm-chk-page]')) {
        swapKeys(keys);
        return true;
      }
      return refreshDrawer().then(function () { return true; });
    }).catch(function () { return false; });
  }

  function sync() {
    if (busy) {
      again = true;
      return busy;
    }
    busy = run().then(function (res) {
      busy = null;
      if (again) {
        again = false;
        return sync();
      }
      return res;
    });
    return busy;
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 300);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
    if (!btn || btn.__hmChkPass) return;
    if (!readMap()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var done = false;
    var go = function () {
      if (done) return;
      done = true;
      btn.__hmChkPass = true;
      btn.click();
      setTimeout(function () { btn.__hmChkPass = false; }, 1500);
    };
    setTimeout(go, 4000);
    (busy || Promise.resolve()).then(function () { return run(true); }).then(go, go);
  }, true);

  function init() {
    sync();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('script[data-hm-chk-map]')) || (n.querySelector && n.querySelector('script[data-hm-chk-map]'))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
